import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'home',
        component: () =>
            import ("@/views/Home.vue")
    },

    {
        path: '/blog',
        name: 'blog',
        component: () =>
            import ('@/views/Blog/Index.vue'),
    },
    {
        path: '/canal-de-denuncia',
        name: 'report',
        component: () =>
            import ('@/views/Pages/Report.vue'),
    },
    {
        path: '/blog/:slug/:type?',
        component: () =>
            import ("@/views/Blog/Detail.vue"),
        name: 'blog_detail'
    },
    {
        path: "/pagina",
        component: () =>
            import ("@/views/Layouts/Page.vue"),

        children: [

            {
                path: 'areas-atuacao',
                name: 'page_expertise_area',
                component: () =>
                    import ("@/views/Pages/ExpertiseArea.vue"),
                meta: {
                    title: 'Áreas de Atuação',
                    image: 'expertise_area.png'
                }
            },

            {
                path: 'equipe',
                name: 'page_team',
                component: () =>
                    import ("@/views/Pages/Team.vue"),
                meta: {
                    title: 'Equipe',
                    image: 'team.png'
                }
            },


            {
                path: 'trabalhe-conosco',
                name: 'page_work_with_us',
                component: () =>
                    import ("@/views/Pages/WorkWithUs.vue"),
                meta: {
                    title: 'Trabalhe Conosco',
                    image: 'work_with_us.jpg'
                }
            },
            {
                path: 'contato',
                name: 'page_contact',
                component: () =>
                    import ("@/views/Pages/Contact.vue"),
                meta: {
                    title: 'Contato',
                    image: 'contact.jpg'
                }
            }, {
                path: 'atendimento',
                name: 'page_online_scheduling',
                component: () =>
                    import ("@/views/Pages/OnlineScheduling.vue"),
                meta: {
                    title: 'Agendamento Online',
                    image: 'contact.jpg'
                }
            },
            {
                path: '/equipe/:slug',
                component: () =>
                    import ('@/views/Team/Detail.vue'),
                name: 'team_detail',
                meta: {
                    title: 'Equipe',
                    image: 'team.png'
                }
            }
        ],
    },
    {
        path: '/pagina/sobre-nos',
        name: 'page_about',
        component: () =>
            import ("@/views/Pages/About.vue"),
        meta: {
            title: 'Sobre Nós',
        }
    },

    {
        path: '/blog/categoria/:category',
        name: 'category',
        component: () =>
            import ('@/views/Blog/Index.vue'),
    },

    {
        path: '/noticias',
        name: 'news',
        component: () =>
            import ('@/views/News.vue')
    },
    {
        path: '/areas-atuacao/:slug',
        component: () =>
            import ('@/views/ExpertiseArea/Detail.vue'),
        name: 'expertise_area_detail'
    },

    {
        path: '/evento/:slug',
        component: () =>
            import ('@/views/Event/Detail.vue'),
        name: 'event_detail',
    },

    {
        path: '/podcast/:slug',
        component: () =>
            import ('@/views/Blog/Detail.vue'),
        name: 'podcast_detail',
    }, {
        path: '/atendimento/seeb',
        name: 'page_online_scheduling_seeb',
        component: () =>
            import ("@/views/Pages/OnlineSchedulingSeeb.vue"),
        meta: {
            title: 'Agendamento Online',
            image: 'contact.jpg'
        }
    },
    {
        path: '/atendimento/simesp',
        name: 'page_online_scheduling_simesp',
        component: () =>
            import ("@/views/Pages/OnlineSchedulingSimesp.vue"),
        meta: {
            title: 'Agendamento Online',
            image: 'contact.jpg'
        }
    },{

        path: '/atendimento/catanduva',
        name: 'page_online_scheduling_catanduva',
        component: () =>
            import ("@/views/Pages/OnlineSchedulingCatanduva.vue"),
        meta: {
            title: 'Agendamento Online',
            image: 'contact.jpg'
        }
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    }
})

export default router